import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import { getFastPeriodsData } from './utils/getFastPeriodsData';
import { useCalendarState } from '../../../context/CalendarContext';
import commonStyles from '../../../Calendar.module.scss';
import styles from '../ChoosePeriod.module.scss';

const Footer = ({ onFastPeriodBtnClick }) => {
  const { view, calendarSheet } = useCalendarState();

  const handleButtonClick = (period) => {
    onFastPeriodBtnClick(period);
  };

  return (
    <span className={styles.footer}>
      {getFastPeriodsData(view).map((item, index) => (
        <Button
          key={item.id}
          className={cn(
            commonStyles.button,
            styles.fastPeriodBtn,
            styles[`fastPeriodBtn-${index + 1}`],
            {
              [styles.active]: calendarSheet.isSame(item.period, view),
            }
          )}
          onClick={
            calendarSheet.isSame(item.period, view)
              ? undefined
              : () => handleButtonClick(item.period)
          }
        >
          {item.icon && item.iconPosition === 'left' && (
            <Icon type={item.icon} />
          )}
          {item.text}
          {item.icon && item.iconPosition === 'right' && (
            <Icon type={item.icon} />
          )}
        </Button>
      ))}
    </span>
  );
};

export default Footer;
